import { render, staticRenderFns } from "./CapacitacionesBase.vue?vue&type=template&id=1fdd4cf6&scoped=true&"
import script from "./CapacitacionesBase.vue?vue&type=script&lang=ts&"
export * from "./CapacitacionesBase.vue?vue&type=script&lang=ts&"
import style0 from "./CapacitacionesBase.vue?vue&type=style&index=0&id=1fdd4cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdd4cf6",
  null
  
)

export default component.exports